const translations = {
  "en": {
    "360º Reports For You": "360º Reports For You"
  },
  "zh-tw": {
    "360º Reports For You": "你的專屬 360° 全方位報告"
  }
};

export default translations;
